/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2014 chukong-inc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
var ListView = ccui.ListView
ListView.prototype.onEvent = function (callback) {
    var self = this
    self.addEventListener(function (sender, eventType) {
        var event = table()
        if (eventType === 0) {
            event.name = "ON_SELECTED_ITEM_START"
        } else {
            event.name = "ON_SELECTED_ITEM_END"
        }
        event.target = sender
        callback(event)
    })
    return self
}
ListView.prototype.onScroll = function (callback) {
    var self = this
    self.addScrollViewEventListener(function (sender, eventType) {
        var event = table()
        if (eventType === 0) {
            event.name = "SCROLL_TO_TOP"
        } else if (eventType === 1) {
            event.name = "SCROLL_TO_BOTTOM"
        } else if (eventType === 2) {
            event.name = "SCROLL_TO_LEFT"
        } else if (eventType === 3) {
            event.name = "SCROLL_TO_RIGHT"
        } else if (eventType === 4) {
            event.name = "SCROLLING"
        } else if (eventType === 5) {
            event.name = "BOUNCE_TOP"
        } else if (eventType === 6) {
            event.name = "BOUNCE_BOTTOM"
        } else if (eventType === 7) {
            event.name = "BOUNCE_LEFT"
        } else if (eventType === 8) {
            event.name = "BOUNCE_RIGHT"
        }
        event.target = sender
        callback(event)
    })
    return self
}
